var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtsy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    fill: "#F27224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5161 32.871C31.5 35.1667 30.0323 35.3172 28.414 35.3172H23.5215C21.9032 35.3172 21.1129 34.6774 21.1129 33.2473V25.8333C21.1129 25.8333 24.6882 25.8333 25.9301 25.9462C26.8333 26.0215 27.3978 26.2849 27.6989 27.5645L28.1129 29.2581H29.5054L29.3925 24.9677L29.5806 20.6398H28.1882L27.7366 22.5215C27.4355 23.7634 27.2473 23.9892 25.9677 24.1398C24.5376 24.2903 21.1129 24.2527 21.1129 24.2527V15.4462C21.1129 15.1075 21.1505 14.9194 21.7151 14.9194H29.2043C30.5215 14.9194 31.2366 16.0108 31.7634 18.1183L32.1774 19.7742H33.457C33.6452 15.0699 33.8333 13 33.8333 13C33.8333 13 30.6344 13.3763 28.7151 13.3763H19.1559L14 13.1882V14.5806L15.7688 14.8817C16.9731 15.1075 17.2742 15.371 17.3871 16.5C17.3871 16.5 17.5 19.7742 17.5 25.1935C17.5 30.5753 17.3871 33.8495 17.3871 33.8495C17.3871 34.828 16.9731 35.2043 15.7688 35.4301L14.0376 35.7688V37.086L19.1559 36.9355H27.7366C29.6559 36.9355 34.1344 37.086 34.1344 37.086C34.2473 35.9194 34.8871 30.5753 35 29.9731H33.7957L32.5161 32.871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtsy);
export default __webpack_public_path__ + "static/media/Etsy.c6da0f7fddc9d3b948fc0a21fd29714d.svg";
export { ForwardRef as ReactComponent };